import { CommandButton } from "components"
import { convertNumber } from "utils"
import { useExportPdf } from "../hooks";
import { exportExcel } from "../functions";
import { DataList } from "../types";

interface TableSectionProps {
  data: DataList[]
  exportDateFormat?: string
}

export const FotherSection = ({ data, exportDateFormat }: TableSectionProps) => {
  const totalBalance = data.reduce((total, item) => total + Number(item?.subtotal)!, 0);

  const exportPdf = useExportPdf({
    data: data,
    dateFilter: exportDateFormat ?? ""
  })

  return (
    <div className="flex justify-between items-center">
      <section className="flex flex-wrap gap-3">
        <CommandButton actiontype="export" onClick={() => exportExcel({
          data: data,
          dateFilter: exportDateFormat ?? ''
        })} />
        <CommandButton actiontype="pdf" onClick={exportPdf.handleExportPdf} />
      </section>

      <div>
        <div className="label-text font-bold flex justify-end text-right">
          <div>
            <div>SUMMARY SUBTOTAL</div>
          </div>
          <div className="mx-2">
            <div>:</div>
          </div>
          <div>
            <div>{totalBalance ? convertNumber(totalBalance)?.intoCurrency : "0"}</div>
          </div>
        </div>
      </div>
    </div>
  )
}